export default "__VITE_ASSET__98lGcOrX__"